import styled from '@emotion/styled';

import { success } from '@widget/toolbox/style/theme/common/ThemeProvider/colors';

export const Wrap = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  background-color: ${success.lighter};
  border-radius: 4px;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.15);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 40px;
    padding: 24px;
  }
`;

export const StyledTitle = styled.h3`
  margin: 0;
  margin-bottom: 24px;
  font-size: 18px;
  line-height: 1.21;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledList = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const StyledItem = styled.li`
  position: relative;
  margin-bottom: 24px;
  padding-left: 40px;
  font-size: 18px;
  line-height: 1.21;
  font-weight: 500;

  &:last-child {
    margin-bottom: 0;
  }

  ::before {
    content: counter(list-item);
    position: absolute;
    top: -1px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    min-width: 24px;
    padding: 2.5px 4px;
    border-radius: 100em;
    font-size: 16px;
    line-height: 1;
    font-weight: 700;
    color: ${({ theme }) => theme.palette.colors.white};
    background-color: ${({ theme }) => theme.palette.colors.primary};
  }
`;
